module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAYCAYAAACbU/80AAAABHNCSVQICAgIfAhkiAAAAAlwSFlzAAALEgAACxIB0t1+/AAAABx0RVh0U29mdHdhcmUAQWRvYmUgRmlyZXdvcmtzIENTNXG14zYAAAENSURBVEiJ7ZbBccIwEEXfZnIPqSBOBYQOaCGVZF2JtgU6SSqI6QA6cCpYLpZmTcAc0OCL30n212i/52tlibsD0Lbth4i8MJBS+sljVR1p9+LufymlDuA5vP/NZoaiGzPrLmmVEICniQmr2hUvMWXgIcQIdkAzjHsz+76i1SBHi+RsRaTi+rfJdWePYDEwu4HSBapqwHp47M3s84pWgw5oRwaArzhDVbehFUdaBbbZwOwRTBnoH2EgRrAhnP/hR/RPq0D5uOUkXAzEg2glImsAdz+a2SFojYi81Srq7nuGjRi74ODu5d6nqu/BRBe1CvTAK4wjOC/QTGj3Ulp69j0QDezD+Ei4Np1pNSjrnQAfaF7c5SYADwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/nav-btn.png
// module id = 18
// module chunks = 1